import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { translateData } from 'utils/translation';
import { dataLayerPush } from 'utils/tracking';

import { SomethingWentWrongImage } from 'images';

import styles from './styles.scss';

const toLocaleText = (error) => {
  const { code, message } = error;
  const translationKey = `ErrorCode:${code || message}`;
  const translatedText = translateData(translationKey);
  const errorText =
    translationKey === translatedText ? `${code}: ${message}` : translatedText;

  return errorText;
};

const logError = (error) => {
  const { code, message } = error;
  dataLayerPush(
    'Acquisition, SelfServe',
    {
      event: 'showError',
      type: code,
      message,
      session_id: window?.DD_RUM?.getInternalContext().session_id,
      payload: error,
    },
    'dlE1',
  );
};

const SomethingWentWrong = () => {
  const error = window?.showSomethingWentWrongError || {
    code: 'UNKNOWN',
    message: 'Unknown Error',
  };

  logError(error);

  const errorText = toLocaleText(error);
  const { code, message, showError } = error;

  return (
    <Fragment>
      <Helmet title={translateData('Something Went Wrong')} />
      <div className={styles.container}>
        <img className={styles.image} src={SomethingWentWrongImage} alt="" />
        <h1>Sorry, something went wrong</h1>
        <p>We are working behind the scenes to resolve the issue.</p>
        {error && (
          <p
            data-tracking={`${code}: ${message}`}
            className={showError ? '' : styles.code}
          >
            {errorText}
          </p>
        )}
        <ul className="water-regional_list water-regional_dark water-regional_water-contact-us-content">
          <li className="water-regional_listItem water-regional_dark water-regional_water-contact-us-content">
            <h2 className="water-regional_title water-regional_dark water-regional_water-contact-us-content">
              Call us
            </h2>
            <h3 className="water-regional_title water-regional_dark water-regional_water-contact-us-content">
              {/* FIXME: The phone number should be parameterized. */}
              <a href="tel:800-728-5508" target="_blank" title="Call us">
                800-728-5508
              </a>
            </h3>
            <div className="water-regional_subtitle water-regional_dark water-regional_water-contact-us-content">
              {/* FIXME: The hours and days should be parameterized. */}
              <div>
                {`We're always here to help. Our hours are 8:00 am-9:00 pm EST Mon-Fri, and we're
                closed on Saturday & Sunday.`}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};

export default connect()(SomethingWentWrong);
